package one.healthium.onboarding.domain.configs


import kotlinx.serialization.Contextual
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.domain.common.Color
import one.healthium.domain.common.ImageMode
import one.healthium.domain.common.Insets
import one.healthium.domain.common.TextStyle
import one.healthium.onboarding.domain.models.GenderText

@Serializable
@SerialName("congrats")
data class CongratsScreenConfig(
    @SerialName("title") val title: String? = null,
    @SerialName("subtitle") val subtitle: String? = null,
    @SerialName("text_align") val textAlign: String? = null,
    @SerialName("image") val image: String? = null,
    @SerialName("image_mode") val imageMode: ImageMode? = null,
    @SerialName("image_insets") val imageInsets: Insets? = null,
    @SerialName("image_safe_area_top") val imageSafeAreaTop: Boolean? = null,
    @SerialName("background_color") @Contextual val backgroundColor: Color? = null,
    @SerialName("cta_title") val ctaTitle: String? = null,
) : ScreenConfig

@Serializable
@SerialName("congrats_v2")
data class CongratsV2ScreenConfig(
    @SerialName("title") val title: String? = null,
    @SerialName("subtitle") val subtitle: String? = null,
    @SerialName("text_align") val textAlign: String? = null,
    @SerialName("background_color_gradient") val backgroundGradient: List<@Contextual Color>? = null,
    @SerialName("cta_title") val ctaTitle: String? = null,
) : ScreenConfig

@Serializable
@SerialName("congrats_v3")
data class CongratsV3ScreenConfig(
    @SerialName("title") val title: String? = null,
    @SerialName("title_style") val titleStyle: TextStyle? = null,
    @SerialName("subtitle") val subtitle: String? = null,
    @SerialName("text_align") val textAlign: String? = null,
    @SerialName("image") val image: GenderText? = null,
    @SerialName("image_mode") val imageMode: ImageMode? = null,
    @SerialName("image_insets") val imageInsets: Insets? = null,
    @SerialName("image_safe_area_top") val imageSafeAreaTop: Boolean? = null,
    @SerialName("image_caption") val imageCaption: String? = null,
    @SerialName("cta_title") val ctaTitle: String? = null,
) : ScreenConfig

@Serializable
@SerialName("coach_intro")
data class CoachIntroScreenConfig(
    @SerialName("title") val title: String? = null,
    @SerialName("subtitle") val subtitle: String? = null,
    @SerialName("image") val image: String? = null,
    @SerialName("image_mode") val imageMode: ImageMode? = null,
    @SerialName("image_insets") val imageInsets: Insets? = null,
    @SerialName("image_safe_area_top") val imageSafeAreaTop: Boolean? = null,
    @SerialName("background_color") @Contextual val backgroundColor: Color? = null,
    @SerialName("cta_title") val ctaTitle: String? = null,
) : ScreenConfig